const STATE_ITEM_KEY = 'RightRevenueState';

export const loadState = () => {
    try {
        const serializedState = localStorage.getItem(STATE_ITEM_KEY);
        if (serializedState == null) return undefined;
        return JSON.parse(serializedState);
    } catch (e) {
        return undefined;
    }
};

export const saveState = (state) => {
    const serializedState = JSON.stringify(state);
    localStorage.setItem(STATE_ITEM_KEY, serializedState);
};
